export * from "./LabeledIcon";
